import request from '@/utils/request'

// 获取路由
export const getRouters = (params) => {
  return request({
    url: '/ecenter/system/menu/getRouters/gemini3',
    method: 'get',
    params: params
  })
}
